import React, {useState} from 'react';

const RESIZABLE = process.env.REACT_APP_RESIZABLE;

export const VendorFavicon = ({vendor}) => {
    const [imgSrc, setImgSrc] = useState(`${RESIZABLE}/favicons/${vendor.slug}.png`);

    const handleError = () => {
        if (vendor.favicon) {
            setImgSrc(`${RESIZABLE}/fit/32x32/${vendor.favicon}`);
        } else {
            setImgSrc(`${RESIZABLE}/favicons/no-logo-vendor.svg`);
        }
    };

    return (
        <img
            style={{objectFit: 'contain'}}
            src={imgSrc}
            alt="Vendor Logo"
            onError={handleError}
            className="sl-h-full sl-w-fit-content sl-company-favicon sl-m-auto "
        />
    );
};
